
import React from "react";
import { Label } from "@/components/ui/label";
import { FormFieldType } from "@/types/form";

interface FieldLabelProps {
  element: FormFieldType;
}

export const FieldLabel: React.FC<FieldLabelProps> = ({ element }) => {
  if (!element.label) return null;
  
  return (
    <div className="mb-2">
      <Label htmlFor={element.id} className="block text-sm font-medium">
        {element.label}
        {element.required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      {element.description && (
        <p className="text-sm text-gray-500 mt-1 whitespace-pre-line">{element.description}</p>
      )}
    </div>
  );
};

export default FieldLabel;
